import React, { useState } from "react";
import _ from "underscore";
import Language from "../lib/Language";
import { useAppContext } from "../contexts/AppContext";

type TGroupInputProps = {
    defaultValue?: any;
    availableValues?: any;
    onUpdate?: any;
};

const GroupInput = (props: TGroupInputProps) => {
    const appContext = useAppContext();
    const [selectedGroup, setSelectedGroup] = useState(0);

    const onGroupChange = (evt) => {
        setSelectedGroup(parseInt(evt.target.value, 10));
    };

    const getCurrentValues = () => {
        const values = props.defaultValue.values[selectedGroup];

        if (values.length > 0 && values[0].value !== undefined) {
            return values.map((val) => val.value);
        }

        return values;
    };

    const onChange = (evt) => {
        let selected = props.availableValues.filter(
            (val, index) => evt.target.options.item(index).selected === true
        );
        if (selected.length > 0 && selected[0].value !== undefined) {
            selected = selected.map((val) => val.value);
        }
        const result = _.clone(props.defaultValue);
        result.values[selectedGroup] = selected;
        props.onUpdate(result);
    };

    const addGroup = () => {
        const result = _.clone(props.defaultValue);
        const name = appContext.user?.promptForGroupName
            ? // eslint-disable-next-line no-alert
              window.prompt(Language.get("nc_reservation_group_name"))
            : "";
        if (name === null) {
            return;
        }
        result.names = result.names.concat([name]);
        result.values = result.values.concat([[props.availableValues[0].value]]);
        props.onUpdate(result);
    };

    return (
        <div className="container groups">
            <span className="topLine">
                <select multiple={false} onChange={onGroupChange} size={1} value={selectedGroup}>
                    {props.defaultValue.names.map((item, index) => (
                        <option key={index} value={index}>
                            {item}
                        </option>
                    ))}
                </select>
                <span className="addButton" onClick={addGroup}>
                    +
                </span>
            </span>
            <select multiple={true} onChange={onChange} size={7} value={getCurrentValues()}>
                {props.availableValues.map((item, index) => (
                    <option key={index} value={item.value !== undefined ? item.value : item}>
                        {item.label !== undefined ? item.label : item}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default GroupInput;
